import { SvgIcon, SvgIconProps } from '@mui/material';

export function ArrowDropDownIcon(props: SvgIconProps) {
  return (
    <SvgIcon {...props}>
      <svg
        width="18"
        height="18"
        viewBox="0 0 18 18"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <g id="trailing icon" clipPath="url(#clip0_402_2413)">
          <path
            id="Vector"
            d="M6.5329 8.78348L8.4754 10.726C8.7679 11.0185 9.2404 11.0185 9.5329 10.726L11.4754 8.78348C11.9479 8.31098 11.6104 7.50098 10.9429 7.50098H7.0579C6.3904 7.50098 6.0604 8.31098 6.5329 8.78348Z"
            fill="#2563EB"
          />
        </g>
        <defs>
          <clipPath id="clip0_402_2413">
            <rect
              width="18"
              height="18"
              fill="white"
              transform="translate(0 0.000976562)"
            />
          </clipPath>
        </defs>
      </svg>
    </SvgIcon>
  );
}
